import { Button, Loading, Warning, FeeSummary } from "@onegovbugs/onegov-react-components";
import styles from "./IndividualFeeBreakdown.module.scss";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { calculateIndividualFees,initIndividualPayment } from "..../../redux/actions";
import { withRouter } from "react-router-dom";


import ScrollToTop from "../../../utils/ScrollToTop";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";
import {saveImportExportApplication} from "../../../redux/actions";

const IndividualFeeBreakdown = props => {
  RedirectIfCaptchaNotSelected(props);
  ScrollToTop();

  const payment = useSelector((state) => state.payment);

  const dispatch = useDispatch();

  const fees = useSelector(state => state.fees);

  const [totalDue, setTotalDue] = useState(0);
  const [gstAmount, setGstAmount] = useState(0);
  const { feesData, feesLoading, feesFailed, feesSucceeded } = fees;
  const { paymentReference, paymentRedirectUrl, loading } = payment;

  useEffect(
    () => {
      dispatch(calculateIndividualFees());
    },
    [dispatch]
  );
  useEffect(() => {
    if (paymentReference && paymentRedirectUrl) {
      window.location.href = `${paymentRedirectUrl}${paymentReference}`;
    }
  }, [paymentReference, paymentRedirectUrl]);

  useEffect(
    () => {
      if (feesData != null && feesData.length > 0) {
        setTotalDue(
          feesData.reduce((total, fc) => total + fc.details.feeAmount, 0)
        );
        setGstAmount(
          feesData.reduce((total, fc) => total + fc.details.gstAmount, 0)
        );
      }
    },
    [feesData, feesLoading, feesFailed, feesSucceeded]
  );

  const submit = () => {
    dispatch(initIndividualPayment());
  };

  return (
    <div className={styles.mainCont}>
      {feesSucceeded == true && feesLoading == false ? (
        <div className={`row`}>
          <div className={`col-lg-12`}>
            <div>
              <FeeSummary dataFeeSummary={feesData} />
              <div className={`row`}>
                <div className={`col-lg-12 col-xs-6`}>
                  {totalDue != 0 ? (
                    <p className={styles.paymentDescritption}>
                      You will be redirected to a secure Service NSW page for
                      payment when you click on the{" "}
                      <strong>'Proceed to payment'</strong> button.
                    </p>
                  ) : (
                    <p className={styles.paymentDescritption}>
                      As part of the NSW Government’s COVID-19 economic stimulus
                      package, we have waived the new application and renewal
                      fee for the minimum renewal term or discounted fees by 1
                      year.
                    </p>
                  )}
                  <div className={`row ` + styles.topMargin128}>
                    <div className={`col-lg-12 col-xs-6`}>
                      <Button
                        className={styles.buttonPayment}
                        onClick={() => {
                          submit();
                        }}
                      >
                      {totalDue != 0 ? "Proceed to payment":"Proceed"}
                      </Button>
                      <Button
                        secondary
                        onClick={() => {
                          dispatch(
                            saveImportExportApplication("", () => {
                                props.history.push(`./dashboard`);
                            })
                          );  
                        }}
                      >
                        Save & exit section
                      </Button>
                      <Loading
                        className={styles.processing + " " + styles.hide}
                        label={false}
                        type={"ajax"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        feesFailed == true && feesLoading == false ? (
          <Warning type={'error'} title={'The was a problem preparing the application for payment'}> 
            <p>Please contact support at <a
              href={'mailto:support@onegov.nsw.gov.au'}>support@onegov.nsw.gov.au</a></p>
          </Warning>
        ):
        (
          <Loading
            className={styles.processing + " " + styles.show}
            label={false}
            type={"ajax"}
          />
        )
      )}
    </div>
  );
};

export default withRouter(props => <IndividualFeeBreakdown {...props} />);
